import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

export default function Products() {
    const { t, lang } = useApp();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/products").then((r) => { setProducts(r.data); setLoading(false); }).catch(() => setLoading(false));
    }, []);

    return (
        <div data-testid="products-page" className="pt-32 pb-24 max-w-[1400px] mx-auto px-6 lg:px-10">
            <div className="mb-16 max-w-2xl">
                <div className="overline mb-4">{lang === "ar" ? "المجموعة" : "The Collection"}</div>
                <h1 className="section-heading text-5xl md:text-6xl text-white mb-4">{t.nav.products}</h1>
                <div className="hairline w-24 mt-6" />
            </div>

            {loading ? (
                <p className="text-white/60">{lang === "ar" ? "جاري التحميل..." : "Loading..."}</p>
            ) : (
                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-10">
                    {products.map((p) => <ProductCard key={p.id} product={p} />)}
                </div>
            )}
        </div>
    );
}
